module.exports = __webpack_public_path__ + "img/reward.690cf81e.svg";